import MUIDataTable from "mui-datatables";
import { Line } from 'react-chartjs-2';
import dateFormat from 'dateformat';
import { Card, CardBody, Col, Row } from 'reactstrap';
import { connect } from "react-redux";
import LocalShippingIcon from '@material-ui/icons/LocalShipping';
import GroupIcon from '@material-ui/icons/Group';
import LocalDrinkIcon from '@material-ui/icons/LocalDrink';
//import ScheduleIcon from '@material-ui/icons/Schedule';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import CancelIcon from '@material-ui/icons/Cancel';
import AssignmentTurnedInIcon from '@material-ui/icons/AssignmentTurnedIn';
//import { toAbsoluteUrl } from "../../../theme/utils/utils";
import PermIdentityTwoToneIcon from '@material-ui/icons/PermIdentityTwoTone';
import EventIcon from '@material-ui/icons/Event';
import ReceiptIcon from '@material-ui/icons/Receipt';
import React from 'react';
import { logincheck } from './Userlogin/Userlogin'
import AccountBalanceIcon from '@material-ui/icons/AccountBalance';

import {
  AreaChart, Area, XAxis, YAxis, CartesianGrid, Tooltip,
} from 'recharts';

const cardChartData3 = {

  datasets: [
    {
      label: 'My First dataset',
      backgroundColor: 'rgba(255,255,255,.2)',
      borderColor: 'rgba(255,255,255,.55)',
      data: [80, 80, 80, 80, 80, 80, 80],
    },
  ],
};

const cardChartOpts3 = {
  tooltips: {
    enabled: false,
    // custom: CustomTooltips
  },
  maintainAspectRatio: false,
  legend: {
    display: false,
  },
  scales: {
    xAxes: [
      {
        display: false,
      }],
    yAxes: [
      {
        display: false,
      }],
  },
  elements: {
    line: {
      borderWidth: 2,
    },
    point: {
      radius: 0,
      hitRadius: 10,
      hoverRadius: 4,
    },
  },
};

class Dashboard extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      userId: "", userRole: "", entityID: "", countArr: {}, orderDataArr: [], partnerActive: "", partnerInActive: "",
      tankerActive: "", tankerInActive: "", borewellActive: "", borewellInActive: "", driverActive: "", driverInActive: "",
      bookedOrderAggregator: 0, deliveredOrderAggregator: 0, scheduledOrderAggregator: 0, cancelledOrderAggregator: 0, growthFetchData: [],
      bookedOrderPartner: 0, deliveredOrderPartner: 0, scheduledOrderPartner: 0, cancelledOrderPartner: 0,
      partnerTankerActive: "", partnerTankerInActive: "", partnerBorewellActive: "", partnerBorewellInActive: "", partnerDriverActive: "", partnerDriverInActive: "",invoiceorderagg: 0,Marketingcount:"", customer_outstanding:"0", tanker_payment:"0", aggregators_amount:"0", 
    }
  }

  componentDidMount() {
	
	// alert(this.props.userRole)
	  
    this.state.userId = this.props.userId;
    this.state.userRole = this.props.userRole;
	
	logincheck(this.state.userId, this.props.mobiledevice).then(({ data: data }) => {
		console.log(data.status_check)
		if(data.status_check === 0) {
			this.props.history.push({ pathname: `/Logout`, state: { userId : this.props.userId , logintoken: 2 } });
		}
	}) 
	
	if (this.state.userRole === 'Sales') {
		this.props.history.push({ pathname: `/water-tank/demo-tank-view`});
	}

    if (this.state.userRole === 'Apartment Customer') {
      const idUrl = process.env.REACT_APP_NODE_ENV + "/api/apart-customer/getApartmentIdByUser/" + this.state.userId
      fetch(idUrl,{
        method:'GET',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': process.env.REACT_APP_API_AUTH_TYPE + btoa(process.env.REACT_APP_API_AUTH_USERNAME + ":" + process.env.REACT_APP_API_AUTH_PASSWORD),
        }
      }).then(
        response => { return response.json(); }
      ).then(data => {
        this.mapID(data)
      })
    }

    else if (this.state.userRole === "Administrator" || this.state.userRole === "Super Admin" || this.state.userRole === "Support User" || this.state.userRole === "CRE"  || this.state.userRole === "Logistics" ) {

      const urlPartnerCount = process.env.REACT_APP_NODE_ENV + "/api/partners/fetchCount"
      fetch(urlPartnerCount,{
        method:'GET',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': process.env.REACT_APP_API_AUTH_TYPE + btoa(process.env.REACT_APP_API_AUTH_USERNAME + ":" + process.env.REACT_APP_API_AUTH_PASSWORD),
        }
      }).then(
        response => { return response.json(); }
      ).then(data => {
        this.setState({ partnerActive: data.activeCount })
        this.setState({ partnerInActive: data.inActiveCount })
      })

      const urlTankerCount = process.env.REACT_APP_NODE_ENV + "/api/fleets/fetchCount"
      fetch(urlTankerCount,{
        method:'GET',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': process.env.REACT_APP_API_AUTH_TYPE + btoa(process.env.REACT_APP_API_AUTH_USERNAME + ":" + process.env.REACT_APP_API_AUTH_PASSWORD),
        }
      }).then(
        response => { return response.json(); }
      ).then(data => {
        this.setState({ tankerActive: data.activeCount })
        this.setState({ tankerInActive: data.inActiveCount })
      })

      const urlBorewellCount = process.env.REACT_APP_NODE_ENV + "/api/borewells/fetchCount"
      fetch(urlBorewellCount,{
        method:'GET',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': process.env.REACT_APP_API_AUTH_TYPE + btoa(process.env.REACT_APP_API_AUTH_USERNAME + ":" + process.env.REACT_APP_API_AUTH_PASSWORD),
        }
      }).then(
        response => { return response.json(); }
      ).then(data => {
        this.setState({ borewellActive: data.activeCount })
        this.setState({ borewellInActive: data.inActiveCount })
      })

      const urlDriverCount = process.env.REACT_APP_NODE_ENV + "/api/drivers/fetchCount"
      fetch(urlDriverCount,{
        method:'GET',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': process.env.REACT_APP_API_AUTH_TYPE + btoa(process.env.REACT_APP_API_AUTH_USERNAME + ":" + process.env.REACT_APP_API_AUTH_PASSWORD),
        }
      }).then(
        response => { return response.json(); }
      ).then(data => {
        this.setState({ driverActive: data.activeCount })
        this.setState({ driverInActive: data.inActiveCount })
      })
      let postDeliveryDate = { deliveryDate: dateFormat(new Date(), "yyyy-mm-dd") }
      fetch(process.env.REACT_APP_NODE_ENV + '/api/orderChild/countOfBookingAggregator', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': process.env.REACT_APP_API_AUTH_TYPE + btoa(process.env.REACT_APP_API_AUTH_USERNAME + ":" + process.env.REACT_APP_API_AUTH_PASSWORD),
        },
        body: JSON.stringify(postDeliveryDate)
      }).then((response) => response.json())
        .then(data => {
          this.setState({ bookedOrderAggregator: data.bookedOrders });
          this.setState({ deliveredOrderAggregator: data.completedOrders });
          this.setState({ scheduledOrderAggregator: data.scheduledOrders });
          this.setState({ cancelledOrderAggregator: data.cancelledOrders });
          this.setState({ invoiceorderagg: data.invoiceOrders });
        })

      fetch(process.env.REACT_APP_NODE_ENV + "/api/customerleads/fetchAll",{
        method:'GET',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': process.env.REACT_APP_API_AUTH_TYPE + btoa(process.env.REACT_APP_API_AUTH_USERNAME + ":" + process.env.REACT_APP_API_AUTH_PASSWORD),
        }
      }).then(
        response => {
          return response.json();
        }
      ).then(data => {
        this.setState({ growthFetchData: data })
      })
    }

    else if (this.state.userRole === 'Corporate Customer') {
      const idUrl = process.env.REACT_APP_NODE_ENV + "/api/corp-customer/getCustomerIdByUser/" + this.state.userId
      fetch(idUrl,{
        method:'GET',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': process.env.REACT_APP_API_AUTH_TYPE + btoa(process.env.REACT_APP_API_AUTH_USERNAME + ":" + process.env.REACT_APP_API_AUTH_PASSWORD),
        }
      }).then(
        response => { return response.json(); }
      ).then(data => this.mapID(data))
    }

    else if (this.state.userRole === 'Individual Customer') {
      const idUrl = process.env.REACT_APP_NODE_ENV + "/api/indiv-customer/getIndividualIdByUser/" + this.state.userId
      fetch(idUrl,{
        method:'GET',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': process.env.REACT_APP_API_AUTH_TYPE + btoa(process.env.REACT_APP_API_AUTH_USERNAME + ":" + process.env.REACT_APP_API_AUTH_PASSWORD),
        }
      }).then(
        response => { return response.json(); }
      ).then(data => {
        this.mapID(data)
      }
      )
    }

    else if (this.state.userRole === 'Partner') {
      let partnerId = 0;
      const url = process.env.REACT_APP_NODE_ENV + "/api/partners/getPartnerIdByUser/" + this.state.userId
      fetch(url,{
        method:'GET',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': process.env.REACT_APP_API_AUTH_TYPE + btoa(process.env.REACT_APP_API_AUTH_USERNAME + ":" + process.env.REACT_APP_API_AUTH_PASSWORD),
        }
      }).then(
        response => { return response.json(); }
      ).then(data => {
        partnerId = data[0].id
        // this.setState({ partnerData: data[0] })
        if (data[0].id !== 0) {
          const urlTankerCount = process.env.REACT_APP_NODE_ENV + "/api/fleets/countOfFleetsForPartners/" + data[0].id
          fetch(urlTankerCount,{
            method:'GET',
            headers: {
              'Content-Type': 'application/json',
              'Authorization': process.env.REACT_APP_API_AUTH_TYPE + btoa(process.env.REACT_APP_API_AUTH_USERNAME + ":" + process.env.REACT_APP_API_AUTH_PASSWORD),
            }
          }).then(
            response => { return response.json(); }
          ).then(data => {
            this.setState({ partnerTankerActive: data.activeCount })
            this.setState({ partnerTankerInActive: data.inActiveCount })
          })

          const urlBorewellCount = process.env.REACT_APP_NODE_ENV + "/api/borewells/countOfBorewellsForPartner/" + data[0].id
          fetch(urlBorewellCount,{
            method:'GET',
            headers: {
              'Content-Type': 'application/json',
              'Authorization': process.env.REACT_APP_API_AUTH_TYPE + btoa(process.env.REACT_APP_API_AUTH_USERNAME + ":" + process.env.REACT_APP_API_AUTH_PASSWORD),
            }
          }).then(
            response => { return response.json(); }
          ).then(data => {
            this.setState({ partnerBorewellActive: data.activeCount })
            this.setState({ partnerBorewellInActive: data.inActiveCount })
          })

          const urlDriverCount = process.env.REACT_APP_NODE_ENV + "/api/drivers/countOfDriversForPartner/" + data[0].id
          fetch(urlDriverCount,{
            method:'GET',
            headers: {
              'Content-Type': 'application/json',
              'Authorization': process.env.REACT_APP_API_AUTH_TYPE + btoa(process.env.REACT_APP_API_AUTH_USERNAME + ":" + process.env.REACT_APP_API_AUTH_PASSWORD),
            }
          }).then(
            response => { return response.json(); }
          ).then(data => {
            this.setState({ partnerDriverActive: data.activeCount })
            this.setState({ partnerDriverInActive: data.inActiveCount })
          })
        }
      }
      )
    }else if (this.state.userRole === "Marketing") {
		let marketinguserid = { userId: this.props.userId }
		  fetch(process.env.REACT_APP_NODE_ENV + '/api/market-target-lead/getcount', {
			method: 'POST',
			headers: {
			  'Content-Type': 'application/json',
			  'Authorization': process.env.REACT_APP_API_AUTH_TYPE + btoa(process.env.REACT_APP_API_AUTH_USERNAME + ":" + process.env.REACT_APP_API_AUTH_PASSWORD),
			},
			body: JSON.stringify(marketinguserid)
		  }).then((response) => response.json())
			.then(data => {
				// console.log(data)
			  this.setState({ Marketingcount: data.marketingcountarr })
			}
		)
    this.amountdetails();
	}else if (this.state.userRole === "Accounts") {
      this.amountdetails();
  }
  }
  
	nextPath(path, value) {
		this.props.history.push({ pathname: path, data: value, state: { data: value } });
	}

  mapID = (data) => {
    let postEntityId = "";
    let data2 = {};
     if (this.state.userRole === "Apartment Customer") {
		
		if(data[0])
		{
			this.setState({ entityID: data[0].apartmentId })
		}
		else {
			this.setState({ entityID: 0 })
		}
		
      
    }
    else if (this.state.userRole === "Corporate Customer") {
		if(data[0])
		{
			this.setState({ entityID: data[0].corporateId })
		}
		else {
			this.setState({ entityID: 0 })
		}
      
    }
    else if (this.state.userRole === "Individual Customer") {
		if(data[0])
		{
			this.setState({ entityID: data[0].individualId })
		}
		else {
			this.setState({ entityID: 0 })
		}
    }
	else {
		 this.setState({ entityID: 0 })
	}
    //this.state.userRole === "Apartment Customer" ? this.setState({ entityID: data[0].apartmentId }) : this.setState({ entityID: data[0].corporateId });
    if (data !== "") {
      postEntityId = { customerId: this.state.entityID }
      fetch(process.env.REACT_APP_NODE_ENV + '/api/orderChild/countOfBooking', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': process.env.REACT_APP_API_AUTH_TYPE + btoa(process.env.REACT_APP_API_AUTH_USERNAME + ":" + process.env.REACT_APP_API_AUTH_PASSWORD),
        },
        body: JSON.stringify(postEntityId)
      }).then((response) => response.json())
        .then(data => {
          data2 = data.scheduledOrders
          // this.state.countArr.push(data);
          this.setState({ countArr: data })
        }
        )
      let postOrderBody = { deliveryDate: dateFormat(new Date(), "yyyy-mm-dd"), customerId: this.state.entityID };
      fetch(process.env.REACT_APP_NODE_ENV + '/api/orderChild/getOrderbyDateAndCustomerId', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': process.env.REACT_APP_API_AUTH_TYPE + btoa(process.env.REACT_APP_API_AUTH_USERNAME + ":" + process.env.REACT_APP_API_AUTH_PASSWORD),
        },
        body: JSON.stringify(postOrderBody)
      }).then((response) => response.json())
        .then(data => {
          let dataArray1 = [];
		  if(data.length > 0){
			  data.map((data) => {
				let status = "";
				if (data.status === "To be Delivered") { status = "Booked" }
				else { status = data.status }
				let mdData = {
				  key: data.id,
				  id: data.orderId, deliveryDate: dateFormat(data.deliveryDate, 'dd-mm-yyyy'), deliverySlot: data.slot, quantum: data.quantity, status: status
				  // status: <Badge pill variant={variant}>{data.status}</Badge>, status1: data.status, actions: data
				};
				dataArray1.push(mdData);
			  });
		  }
          this.setState({ orderDataArr: dataArray1 });
        })
    }
  }

  amountdetails = () => {
      fetch(process.env.REACT_APP_NODE_ENV + '/api/orderChild/amountdetails', {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': process.env.REACT_APP_API_AUTH_TYPE + btoa(process.env.REACT_APP_API_AUTH_USERNAME + ":" + process.env.REACT_APP_API_AUTH_PASSWORD),
        }
      }).then((response) => response.json())
        .then(data => {
         this.setState({ customer_outstanding: (data.customer_price_received[0].customer_outstanding > 0 ? data.customer_price_received[0].customer_outstanding : '0'), tanker_payment: (data.tanker_price_settled[0].tanker_payment > 0 ? data.tanker_price_settled[0].tanker_payment :'0'), aggregators_amount: (data.aggregators_amount[0].aggregators_amount > 0 ? data.aggregators_amount[0].aggregators_amount :'0') });
        })

        
  }

  render() {

    let countArr = this.state.countArr;
    let orderDataArr = this.state.orderDataArr;


    let growthData1 = [];
    this.state.growthFetchData.map(data => {
      let month = dateFormat(data.createdAt, 'mmm')
      let newData = { name: data.name, month: month }
      growthData1.push(newData);
    })

    let janCount = 0, febCount = 0, marCount = 0, aprCount = 0, mayCount = 0, junCount = 0, julCount = 0, augCount = 0, sepCount = 0, octCount = 0, novCount = 0, decCount = 0, jan1Count = 0;
    growthData1.map(data => {
    
      
      
      if (data.month === "Jan") { sepCount = sepCount + 1 }
      if (data.month === "Feb") { octCount = octCount + 1 }
      if (data.month === "Mar") { novCount = octCount + 1 }
      if (data.month === "Apr") { decCount = octCount + 1 }
      if (data.month === "May") { decCount = octCount + 1 }
      if (data.month === "Jun") { decCount = octCount + 1 }
      if (data.month === "Jul") { decCount = octCount + 1 }
      if (data.month === "Aug") { decCount = octCount + 1 }
      if (data.month === "Sep") { decCount = octCount + 1 }
     

    })

    const growthData = [
      
      
      
	  {
        name: 'Jan', count: sepCount, pv: 4300, amt: 2100,
      },
	  {
        name: 'Feb', count: octCount, pv: 4300, amt: 2100,
      },
	  {
        name: 'Mar', count: octCount, pv: 4300, amt: 2181,
      },
	  {
        name: 'Apr', count: octCount, pv: 4300, amt: 2500,
      },
      {
        name: 'May', count: octCount, pv: 4300, amt: 2500,
      },
      {
        name: 'Jun', count: octCount, pv: 4300, amt: 2500,
      },
      {
        name: 'Jul', count: octCount, pv: 4300, amt: 2500,
      },
      {
        name: 'Aug', count: octCount, pv: 4300, amt: 2500,
      },
      {
        name: 'Sep', count: octCount, pv: 4300, amt: 2500,
      },
	  
    ];

    const customerColumns = [
      {
        name: "id",
        label: "ID",
        options: {
          filter: true,
          sort: true,
        }
      },
      {
        name: "deliveryDate",
        label: "Delivery Date",
        options: {
          filter: true,
          sort: true,
        }
      },
      {
        name: "deliverySlot",
        label: "Delivery Slot",
        options: {
          filter: true,
          sort: true,
        }
      },
      {
        name: "quantum",
        label: "Order Quantum",
        options: {
          filter: true,
          sort: true,
        }
      },
      {
        name: "status",
        label: "Status",
        options: {
          filter: true,
          sort: true,
        }
      }
    ];

    let completedOrders = "0", scheduledOrders = "0", deliveredOrders = "0";

    const customerOptions = {
      filterType: 'dropdown', rowsPerPageOptions: [5, 10, 15, 20], selectableRows: "none", download: false,
      print: false
    };

    const UserView = (
      <div>
        <Row>
          <div className="col-md-3" >

            <div className="card" style={{ backgroundImage: 'linear-gradient(to right,#fff,#fff)', border: '1px solid rgba(0, 0, 0, 0.125)', boxShadow: ' 10px 10px rgba(0,0,0,0.2)' }}>
              <CardBody className="pb-0">
                <div className="float-right">
                  <div className="icon_container">
                    <CheckCircleIcon style={{ color: "blue" }}></CheckCircleIcon>
                  </div>
                </div>
              </CardBody>
              <center>
                <div className="text_contanier">
                  <h3 className="heading" style={{ color: "#000000", paddingTop: '2vh' }}>Booked</h3>
                  <h5 className="value" style={{ color: "#000000" }}>{countArr.bookedOrders}</h5>
                  {/*  <h3 class="value" style={{ color: "#000000" }}>Offline {this.state.borewellInActive}</h3> */}
                  <div className="chart-wrapper" style={{ height: '25px' }}></div>
                </div>
              </center>
            </div>
          </div>
          <div className="col-md-3" >
            <div className="card" style={{ backgroundImage: 'linear-gradient(to right,#fff,#fff)', border: '1px solid rgba(0, 0, 0, 0.125)', boxShadow: ' 10px 10px rgba(0,0,0,0.2)' }}>
              <CardBody className="pb-0">
                <div className="float-right">
                  <div className="icon_container">
                    <EventIcon style={{ color: "#dc3545" }}></EventIcon >
                  </div>
                </div>
              </CardBody>
              <center>
                <div className="text_contanier">
                  <h3 className="heading" style={{ color: "#000000", paddingTop: '2vh' }}>Scheduled</h3>
                  <h5 className="value" style={{ color: "#000000" }}>{countArr.scheduledOrders}</h5>
                  {/* <h3 class="value" style={{ color: "#000000" }}>Offline {this.state.driverInActive}</h3> */}
                  <div className="chart-wrapper" style={{ height: '25px' }}></div>
                </div>
              </center>
            </div>
          </div>
          <div className="col-md-3">
            <div className="card" style={{ backgroundImage: 'linear-gradient(to right,#fff,#fff)', border: '1px solid rgba(0, 0, 0, 0.125)', boxShadow: ' 10px 10px rgba(0,0,0,0.2)' }}>
              <CardBody className="pb-0">
                <div className="float-right">
                  <div className="icon_container">
                    <LocalShippingIcon style={{ color: "green" }}></LocalShippingIcon>
                  </div>
                </div>
              </CardBody>
              <center>
                <div className="text_contanier">
                  <h3 className="heading" style={{ color: "#000000", paddingTop: '2vh' }}>Delivered</h3>
                  <h5 className="value" style={{ color: "#000000" }}>{countArr.completedOrders}</h5>
                  {/* <h3 class="value" style={{ color: "#000000" }}>Offline {this.state.driverInActive}</h3> */}
                  <div className="chart-wrapper" style={{ height: '25px' }}></div>
                </div>
              </center>
            </div>
          </div>

          <div className="col-md-3">
            <div className="card" style={{ backgroundImage: 'linear-gradient(to right,#fff,#fff)', border: '1px solid rgba(0, 0, 0, 0.125)', boxShadow: ' 10px 10px rgba(0,0,0,0.2)' }}>
              <CardBody className="pb-0">
                <div className="float-right">
                  <div className="icon_container">
                    <CancelIcon style={{ color: "red" }}></CancelIcon>
                  </div>
                </div>
              </CardBody>
              <center>
                <div className="text_contanier">
                  <h3 className="heading" style={{ color: "#000000", paddingTop: '2vh' }}>Cancelled</h3>
                  <h5 className="value" style={{ color: "#000000" }}>{countArr.cancelledOrders}</h5>
                  {/* <h3 class="value" style={{ color: "#000000" }}>Offline {this.state.driverInActive}</h3> */}
                  <div className="chart-wrapper" style={{ height: '25px' }}></div>
                </div>
              </center>
            </div>
          </div>
		  
		</Row>
        <div style={{ marginTop: '50px' }}>
          <MUIDataTable
            title={"Today Orders"}
            data={this.state.orderDataArr}
            columns={customerColumns}
            options={customerOptions} />
        </div>
      </div>
    );
    //const data112 = dataArr;
    const AdminView = (<>
      <Row>
        <Col xs="12" sm="6" lg="3">
          <Card className="bg-primary" style={{ backgroundImage: 'linear-gradient(to right,#ffdac1	,#e2f0cb)', border: '1px solid rgba(0, 0, 0, 0.125)', boxShadow: ' 10px 10px rgba(0,0,0,0.2)' }}>
            <CardBody className="pb-0">
              <div className="float-right">
                <div className="icon_container">
                  <GroupIcon style={{ color: "#000080" }}></GroupIcon>
                </div>
              </div>
              <h3 className="heading" style={{ color: "#000000", paddingTop: '2vh' }}>Partners</h3>
              <h5 className="value" style={{ color: "#000000" }}>  <a href="/partner/partner-list" style={{ color: "#000000" }}>Active &nbsp; &nbsp; &nbsp;: </a> {this.state.partnerActive}</h5>
              <h5 className="value" style={{ color: "#000000" }}> <a href="/partner/partner-list" style={{ color: "#000000" }}>InActive &nbsp;: </a>{this.state.partnerInActive}</h5>
            </CardBody>
            <div className="chart-wrapper" style={{ height: '70px' }}>
              <Line data={cardChartData3} options={cardChartOpts3} height={70} />
            </div>
          </Card>
        </Col>
        <Col xs="12" sm="6" lg="3">
          <Card className="bg-success" style={{ backgroundImage: 'linear-gradient(to right	,#b5ead7,#b5ead7)', border: '1px solid rgba(0, 0, 0, 0.125)', boxShadow: ' 10px 10px rgba(0,0,0,0.2)' }}>
            <CardBody className="pb-0">
              <div className="float-right">
                <div className="icon_container">
                  <LocalDrinkIcon style={{ color: "#000080" }}></LocalDrinkIcon>
                </div>
              </div>
              <h3 className="heading" style={{ color: "#000000", paddingTop: '2vh' }}>Borewells</h3>
              <h5 className="value" style={{ color: "#000000" }}>  <a href="/manage/borewell-summary" style={{ color: "#000000" }}> Active &nbsp; &nbsp; &nbsp;:</a> {this.state.borewellActive}</h5>
              <h5 className="value" style={{ color: "#000000" }}> <a href="/manage/borewell-summary" style={{ color: "#000000" }}> InActive &nbsp;:</a> {this.state.borewellInActive}</h5>
            </CardBody>
            <div className="chart-wrapper" style={{ height: '70px' }}>
              <Line data={cardChartData3} options={cardChartOpts3} height={70} />
            </div>
          </Card>
        </Col>

        <Col xs="12" sm="6" lg="3">
          <Card className="text-white bg-warning" style={{
            backgroundImage: 'linear-gradient(to right,	#ffdac1	,#e2f0cb)', border: '1px solid rgba(0, 0, 0, 0.125)', boxShadow: ' 10px 10px rgba(0,0,0,0.2)'
          }}>
            <CardBody className="pb-0">
              <div className="float-right">
                <div className="icon_container">
                  <LocalShippingIcon style={{ color: "#000080" }}></LocalShippingIcon>
                </div>
              </div>
              <h3 className="heading" style={{ color: "#000000", paddingTop: '2vh' }}>Tankers</h3>
              <h5 className="value" style={{ color: "#000000" }}>  <a href="/manage/fleet-summary" style={{ color: "#000000" }}>Active &nbsp; &nbsp; &nbsp;: </a> {this.state.tankerActive}</h5>
              <h5 className="value" style={{ color: "#000000" }}> <a href="/manage/fleet-summary" style={{ color: "#000000" }}>InActive &nbsp;: </a>{this.state.tankerInActive}</h5>
            </CardBody>
            <div className="chart-wrapper" style={{ height: '70px' }}>
              <Line data={cardChartData3} options={cardChartOpts3} height={70} />
            </div>
          </Card>
        </Col>
        <Col xs="12" sm="6" lg="3">
          <Card className="text-white bg-danger" style={{ backgroundImage: 'linear-gradient(to right,#b5ead7,#b5ead7)', border: '1px solid rgba(0, 0, 0, 0.125)', boxShadow: ' 10px 10px rgba(0,0,0,0.2)' }}>
            <CardBody className="pb-0">
              <div className="float-right">
                <div className="icon_container">
                  <PermIdentityTwoToneIcon style={{ color: "#000080" }}></PermIdentityTwoToneIcon>
                </div>
              </div>
              <h3 className="heading" style={{ color: "#000000", paddingTop: '2vh' }}>Drivers</h3>
              <h5 className="value" style={{ color: "#000000" }}>  <a href="/manage/driver-summary" style={{ color: "#000000" }}> Active &nbsp; &nbsp; &nbsp;:</a> {this.state.driverActive}</h5>
              <h5 className="value" style={{ color: "#000000" }}> <a href="/manage/driver-summary" style={{ color: "#000000" }}> InActive &nbsp;:</a> {this.state.driverInActive}</h5>
            </CardBody>
            <div className="chart-wrapper" style={{ height: '70px' }}>
              <Line data={cardChartData3} options={cardChartOpts3} height={70} />
            </div>
          </Card>
        </Col>
      </Row>
      <br />
      <div className="row">
        <div className="col-md-6" >
          {/* <div className="card"  style={{backgroundImage:'linear-gradient(to right,	#decaea,#391e49)',border: '1px solid rgba(0, 0, 0, 0.125)',boxShadow:'5px 10px 8px 10px #888888', paddingTop: '2vh', paddingLeft: '5vh', paddingRight: '5vh' }} > */}
          <div className="card" style={{ backgroundImage: 'linear-gradient(to right,	#ffe3ee,#ffb6c1)', border: '1px solid rgba(0, 0, 0, 0.125)', boxShadow: '5px 10px 2px 2px #888888', paddingTop: '2vh', paddingLeft: '5vh', paddingRight: '5vh', fontfamily: 'sans-serif', fontColor: '#000080' }} >
            <center>
              <div className="row">
                <div className="col-md-1">
                </div>
                <div className="col-md-1" style={{ paddingRight: '0px' }}>
                  <div style={{ float: 'right', fontSize: '11px', fontWeight: 'bold' }}>
                    <br />
                    <br />
                    <br />
                    <br />
                    N
              <br />
                    o
              <br />
                    <br />
                    o
              <br />
                    f
              <br />
                    <br />
                    L
              <br />
                    e
              <br />
                    a
              <br />
                    d
              <br />
                    s
              <br />
                  </div>
                </div>
                <div className="col-md-10" style={{ paddingRight: '0px', paddingLeft: '0px', fontFamily: 'sans-serif', fontColor: '#000080' }}>
                  <br />
                  <div style={{ fontSize: '18px', fontWeight: 'bold' }}>Leads</div>
                  <AreaChart style={{ float: 'left' }}
                    width={350}
                    height={250}
                    data={growthData}
                    margin={{
                      top: 10, right: 30, left: 0, bottom: 0,
                    }}
                  >
                    <CartesianGrid strokeDasharray="3 3" />
                    <XAxis dataKey="name" />
                    <YAxis />
                    <Tooltip />
                    <Area type="monotone" dataKey="count" stroke="#893843" fill="#EFBBCC" />
                  </AreaChart>

                </div>
              </div>
              <div><b>Year 2021</b></div>
            </center>
          </div>
        </div>
        {/* <div className="col-md-6"  style={{backgroundImage:'linear-gradient(to right,	#cccccc,#4c4c4c)',border: '1px solid rgba(0, 0, 0, 0.125)',boxShadow:'5px 10px 8px 10px #888888', paddingTop: '2vh', paddingLeft: '5vh', paddingRight: '5vh' }}> */}
        <div className="col-md-6" style={{ border: '1px solid rgba(0, 0, 0, 0.125)', boxShadow: '5px 10px 2px 2px #8F8F8F', paddingTop: '2vh', paddingLeft: '5vh', paddingRight: '5vh' }}>
          <center style={{ fontSize: '3vh', color: "#000000" }}> <b>Today's Order</b></center>

          <Row style={{ marginTop: "20px" }}>
            <Col>
              <Card style={{ backgroundImage: 'linear-gradient(to right,#ffdac1	,#e2f0cb)', border: '1px solid rgba(0, 0, 0, 0.125)', boxShadow: '10px 10px rgba(0,0,0,0.2)' }}>
                <div >
                  <CardBody className="pb-0">
                    <div className="float-right">
                      <div className="icon_container">
                        <CheckCircleIcon style={{ color: "#000080" }}></CheckCircleIcon>
                      </div>
                    </div>
                  </CardBody>
                  <center>

                    <h3 className="heading" style={{ color: "#000000", paddingTop: '2vh' }}>To be Delivered</h3>
                    <h3 className="value" style={{ color: "#000000" }}>{this.state.bookedOrderAggregator}</h3>

                  </center>
                </div>
              </Card>
            </Col>
            <Col>
              <Card style={{ backgroundImage: 'linear-gradient(to right,#b5ead7,#b5ead7)', border: '1px solid rgba(0, 0, 0, 0.125)', boxShadow: ' 10px 10px rgba(0,0,0,0.2)' }}>
                <div >
                  <CardBody className="pb-0">
                    <div className="float-right">
                      <div className="icon_container">
                        <AssignmentTurnedInIcon style={{ color: "#000080" }}></AssignmentTurnedInIcon>
                      </div>
                    </div>
                  </CardBody>
                  <center>

                    <h3 className="heading" style={{ color: "#000000", paddingTop: '2vh' }}>Allocated</h3>
                    <h3 className="value" style={{ color: "#000000" }}>{this.state.scheduledOrderAggregator}</h3>

                  </center>
                </div>
              </Card>
            </Col>
          </Row>

          <Row style={{ marginTop: "30px" }}>
            <Col>
              <Card style={{ backgroundImage: 'linear-gradient(to right,#b5ead7,#b5ead7)', border: '1px solid rgba(0, 0, 0, 0.125)', boxShadow: '10px 10px rgba(0,0,0,0.2)' }}>
                <div >
                  <CardBody className="pb-0">
                    <div className="float-right">
                      <div className="icon_container">
                        <LocalShippingIcon style={{ color: "#000080" }}></LocalShippingIcon >
                      </div>
                    </div>
                  </CardBody>
                  <center>
                    <h3 className="heading" style={{ color: "#000000", paddingTop: '2vh' }}>Delivered</h3>
                    <h3 className="value" style={{ color: "#000000" }}>{this.state.deliveredOrderAggregator}</h3>
                  </center>
                </div>
              </Card>
            </Col>
            <Col>
              <Card style={{ backgroundImage: 'linear-gradient(to right,#ffdac1	,#e2f0cb)', border: '1px solid rgba(0, 0, 0, 0.125)', boxShadow: ' 10px 10px rgba(0,0,0,0.2)' }}>
                <div >
                  <center>
                    <CardBody className="pb-0">
                      <div className="float-right">
                        <div className="icon_container">
                          <CancelIcon style={{ color: "000080" }}></CancelIcon>
                        </div>
                      </div>
                    </CardBody>
                    <h3 className="heading" style={{ color: "#000000", paddingTop: '2vh' }}>Cancelled</h3>
                    <h3 className="value" style={{ color: "#000000" }}>{this.state.cancelledOrderAggregator}</h3>

                  </center>
                </div>
              </Card> 
			  
			 
            </Col>
          </Row>
		   <Row style={{ marginTop: "30px" }} >
			  <Col>
              <Card style={{ backgroundImage: 'linear-gradient(to right,#ffdac1	,#e2f0cb)', border: '1px solid rgba(0, 0, 0, 0.125)', boxShadow: ' 10px 10px rgba(0,0,0,0.2)' }}>
                <div >
                  <center>
                    <CardBody className="pb-0">
                      <div className="float-right">
                        <div className="icon_container">
                          <ReceiptIcon style={{ color: "000080" }}></ReceiptIcon>
                        </div>
                      </div>
                    </CardBody>
                    <h3 className="heading" style={{ color: "#000000", paddingTop: '2vh' }}>Invoice</h3>
                    <h3 className="value" style={{ color: "#000000" }}>{this.state.invoiceorderagg}</h3>

                  </center>
                </div>
              </Card>
			  
			  </Col>
			</Row>
		  

        </div>
      </div>


    </>);

    let PartnerView = (<>

     
      <Row>
        <Col xs="12" sm="6" lg="4">
          <Card className="bg-success" style={{ backgroundImage: 'linear-gradient(to right,	#fff	,#fff)', border: '1px solid rgba(0, 0, 0, 0.125)', boxShadow: ' 10px 10px rgba(0,0,0,0.2)' }}>
            <CardBody className="pb-0">
              <div className="float-right">
                <div className="icon_container">
                  <LocalDrinkIcon style={{ color: "#000080" }}></LocalDrinkIcon>
                </div>
              </div>
              <h3 className="heading" style={{ color: "#000000", paddingTop: '2vh' }}>Borewells</h3>
              <h5 className="value" style={{ color: "#000000" }}>  <text style={{ color: "#000000" }}> Active &nbsp; &nbsp; &nbsp;:</text> {this.state.partnerBorewellActive}</h5>
              <h5 className="value" style={{ color: "#000000" }}> <text style={{ color: "#000000" }}> InActive &nbsp;:</text> {this.state.partnerBorewellInActive}</h5>
            </CardBody>
            <div className="chart-wrapper" style={{ height: '50px' }}>
              <Line data={cardChartData3} options={cardChartOpts3} height={50} />
            </div>
          </Card>
        </Col>

        <Col xs="12" sm="6" lg="4">
          <Card className="text-white bg-warning" style={{
            backgroundImage: 'linear-gradient(to right,	#fff,#fff)', border: '1px solid rgba(0, 0, 0, 0.125)', boxShadow: ' 10px 10px rgba(0,0,0,0.2)'
          }}>
            <CardBody className="pb-0">
              <div className="float-right">
                <div className="icon_container">
                  <LocalShippingIcon style={{ color: "#ffee00" }}></LocalShippingIcon>
                </div>
              </div>
              <h3 className="heading" style={{ color: "#000000", paddingTop: '2vh' }}>Tankers</h3>
              <h5 className="value" style={{ color: "#000000" }}>  <text style={{ color: "#000000" }}>Active &nbsp; &nbsp; &nbsp;: </text> {this.state.partnerTankerActive}</h5>
              <h5 className="value" style={{ color: "#000000" }}> <text style={{ color: "#000000" }}>InActive &nbsp;: </text>{this.state.partnerTankerInActive}</h5>
            </CardBody>
            <div className="chart-wrapper" style={{ height: '50px' }}>
              <Line data={cardChartData3} options={cardChartOpts3} height={50} />
            </div>
          </Card>
        </Col>
        <Col xs="12" sm="6" lg="4">
          <Card className="text-white bg-danger" style={{ backgroundImage: 'linear-gradient(to right,	#fff	,#fff)', border: '1px solid rgba(0, 0, 0, 0.125)', boxShadow: ' 10px 10px rgba(0,0,0,0.2)' }}>
            <CardBody className="pb-0">
              <div className="float-right">
                <div className="icon_container">
                  <PermIdentityTwoToneIcon style={{ color: "#000000" }}></PermIdentityTwoToneIcon>
                </div>
              </div>
              <h3 className="heading" style={{ color: "#000000", paddingTop: '2vh' }}>Drivers</h3>
              <h5 className="value" style={{ color: "#000000" }}>  <text style={{ color: "#000000" }}> Active &nbsp; &nbsp; &nbsp;:</text> {this.state.partnerDriverActive}</h5>
              <h5 className="value" style={{ color: "#000000" }}> <text style={{ color: "#000000" }}> InActive &nbsp;:</text> {this.state.partnerDriverInActive}</h5>
            </CardBody>
            <div className="chart-wrapper" style={{ height: '50px' }}>
              <Line data={cardChartData3} options={cardChartOpts3} height={50} />
            </div>
          </Card>
        </Col>
      </Row>

    </>);
	
	const MarketingView = (
      <div>
        <Row>
          <div className="col-md-3" >

            <div className="card" style={{ backgroundImage: 'linear-gradient(to right,#fff,#fff)', border: '1px solid rgba(0, 0, 0, 0.125)', boxShadow: ' 10px 10px rgba(0,0,0,0.2)', cursor:'pointer' }} onClick={() => this.nextPath("/transaction/order/pendingorders")} >
              <CardBody className="pb-0">
                <div className="float-right">
                  <div className="icon_container">
                  <AccountBalanceIcon style={{ color: "green" }}></AccountBalanceIcon>
                  </div>
                </div>
              </CardBody>
              <center>
                <div className="text_contanier">
                  <h5 className="heading" style={{ color: "#000000", paddingTop: '2vh' }}>Customer Outstanding</h5>
                  <h3 className="value" style={{ color: "#000000" }}>Rs.{this.state.customer_outstanding}</h3>
                  {/*  <h3 class="value" style={{ color: "#000000" }}>Offline {this.state.borewellInActive}</h3> */}
                  <div className="chart-wrapper" style={{ height: '25px' }}></div>
                </div>
              </center>
            </div>
          </div>
          <div className="col-md-3" >
            <div className="card" style={{ backgroundImage: 'linear-gradient(to right,#fff,#fff)', border: '1px solid rgba(0, 0, 0, 0.125)', boxShadow: ' 10px 10px rgba(0,0,0,0.2)', cursor:'pointer' }} onClick={() => this.nextPath("/transaction/order/pendingorders")} >
              <CardBody className="pb-0">
                <div className="float-right">
                  <div className="icon_container">
                  <AccountBalanceIcon style={{ color: "red" }}></AccountBalanceIcon>
                  </div>
                </div>
              </CardBody>
              <center>
                <div className="text_contanier">
                  <h5 className="heading" style={{ color: "#000000", paddingTop: '2vh' }}>Tanker Payment</h5>
                  <h3 className="value" style={{ color: "#000000" }}>Rs.{this.state.tanker_payment}</h3>
                  {/* <h3 class="value" style={{ color: "#000000" }}>Offline {this.state.driverInActive}</h3> */}
                  <div className="chart-wrapper" style={{ height: '25px' }}></div>
                </div>
              </center>
            </div>
          </div>
          <div className="col-md-3">
            <div className="card" style={{ backgroundImage: 'linear-gradient(to right,#fff,#fff)', border: '1px solid rgba(0, 0, 0, 0.125)', boxShadow: ' 10px 10px rgba(0,0,0,0.2)', cursor:'pointer' }} onClick={() => this.nextPath("/transaction/order/pendingorders")} >
              <CardBody className="pb-0">
                <div className="float-right">
                  <div className="icon_container">
                    <AccountBalanceIcon style={{ color: "#0008ff" }}></AccountBalanceIcon>
                  </div>
                </div>
              </CardBody>
              <center>
                <div className="text_contanier">
                  <h5 className="heading" style={{ color: "#000000", paddingTop: '2vh' }}>Aggregators Amount</h5>
                  <h3 className="value" style={{ color: "#000000" }}>Rs.{this.state.aggregators_amount}</h3>
                  {/* <h3 class="value" style={{ color: "#000000" }}>Offline {this.state.driverInActive}</h3> */}
                  <div className="chart-wrapper" style={{ height: '25px' }}></div>
                </div>
              </center>
            </div>
          </div>
          <div className="col-md-3" >
            <div className="card" style={{ backgroundImage: 'linear-gradient(to right,#fff,#fff)', border: '1px solid rgba(0, 0, 0, 0.125)', boxShadow: ' 10px 10px rgba(0,0,0,0.2)', cursor:'pointer' }} onClick={() => this.nextPath("/market-target-lead/customer-particular-list", "Cold")} >
              <CardBody className="pb-0">
                <div className="float-right">
                  <div className="icon_container">
                    <CheckCircleIcon style={{ color: "blue" }}></CheckCircleIcon>
                  </div>
                </div>
              </CardBody>
              <center>
                <div className="text_contanier">
                  <h3 className="heading" style={{ color: "#000000", paddingTop: '2vh' }}>Cold</h3>
                  <h5 className="value" style={{ color: "#000000" }}>{this.state.Marketingcount[0]}</h5>
                  {/*  <h3 class="value" style={{ color: "#000000" }}>Offline {this.state.borewellInActive}</h3> */}
                  <div className="chart-wrapper" style={{ height: '25px' }}></div>
                </div>
              </center>
            </div>
          </div>
		  </Row>
      <Row style={{marginTop: "20px"}}>          
          <div className="col-md-3" >
            <div className="card" style={{ backgroundImage: 'linear-gradient(to right,#fff,#fff)', border: '1px solid rgba(0, 0, 0, 0.125)', boxShadow: ' 10px 10px rgba(0,0,0,0.2)', cursor:'pointer' }} onClick={() => this.nextPath("/market-target-lead/customer-particular-list", "Warm")} >
              <CardBody className="pb-0">
                <div className="float-right">
                  <div className="icon_container">
                    <EventIcon style={{ color: "#dc3545" }}></EventIcon >
                  </div>
                </div>
              </CardBody>
              <center>
                <div className="text_contanier">
                  <h3 className="heading" style={{ color: "#000000", paddingTop: '2vh' }}>Warm</h3>
                  <h5 className="value" style={{ color: "#000000" }}>{this.state.Marketingcount[1]}</h5>
                  {/* <h3 class="value" style={{ color: "#000000" }}>Offline {this.state.driverInActive}</h3> */}
                  <div className="chart-wrapper" style={{ height: '25px' }}></div>
                </div>
              </center>
            </div>
          </div>
          <div className="col-md-3">
            <div className="card" style={{ backgroundImage: 'linear-gradient(to right,#fff,#fff)', border: '1px solid rgba(0, 0, 0, 0.125)', boxShadow: ' 10px 10px rgba(0,0,0,0.2)', cursor:'pointer' }} onClick={() => this.nextPath("/market-target-lead/customer-particular-list", "Hot")} >
              <CardBody className="pb-0">
                <div className="float-right">
                  <div className="icon_container">
                    <LocalShippingIcon style={{ color: "green" }}></LocalShippingIcon>
                  </div>
                </div>
              </CardBody>
              <center>
                <div className="text_contanier">
                  <h3 className="heading" style={{ color: "#000000", paddingTop: '2vh' }}>Hot</h3>
                  <h5 className="value" style={{ color: "#000000" }}>{this.state.Marketingcount[2]}</h5>
                  {/* <h3 class="value" style={{ color: "#000000" }}>Offline {this.state.driverInActive}</h3> */}
                  <div className="chart-wrapper" style={{ height: '25px' }}></div>
                </div>
              </center>
            </div>
          </div>

          <div className="col-md-3">
            <div className="card" style={{ backgroundImage: 'linear-gradient(to right,#fff,#fff)', border: '1px solid rgba(0, 0, 0, 0.125)', boxShadow: ' 10px 10px rgba(0,0,0,0.2)', cursor:'pointer' }} onClick={() => this.nextPath("/market-target-lead/customer-particular-list", "Converted")} >
              <CardBody className="pb-0">
                <div className="float-right">
                  <div className="icon_container">
                    <CancelIcon style={{ color: "red" }}></CancelIcon>
                  </div>
                </div>
              </CardBody>
              <center>
                <div className="text_contanier">
                  <h3 className="heading" style={{ color: "#000000", paddingTop: '2vh' }}>Converted</h3>
                  <h5 className="value" style={{ color: "#000000" }}>{this.state.Marketingcount[3]}</h5>
                  {/* <h3 class="value" style={{ color: "#000000" }}>Offline {this.state.driverInActive}</h3> */}
                  <div className="chart-wrapper" style={{ height: '25px' }}></div>
                </div>
              </center>
            </div>
          </div>
          <div className="col-md-3">
            <div className="card" style={{ backgroundImage: 'linear-gradient(to right,#fff,#fff)', border: '1px solid rgba(0, 0, 0, 0.125)', boxShadow: ' 10px 10px rgba(0,0,0,0.2)', cursor:'pointer' }} onClick={() => this.nextPath("/market-target-lead/customer-particular-list", "Not Interested")} >
              <CardBody className="pb-0">
                <div className="float-right">
                  <div className="icon_container">
                    <CancelIcon style={{ color: "red" }}></CancelIcon>
                  </div>
                </div>
              </CardBody>
              <center>
                <div className="text_contanier">
                  <h3 className="heading" style={{ color: "#000000", paddingTop: '2vh' }}>Not Interested</h3>
                  <h5 className="value" style={{ color: "#000000" }}>{this.state.Marketingcount[4]}</h5>
                  {/* <h3 class="value" style={{ color: "#000000" }}>Offline {this.state.driverInActive}</h3> */}
                  <div className="chart-wrapper" style={{ height: '25px' }}></div>
                </div>
              </center>
            </div>
          </div>
		  </Row>
		  
		  <Row style={{marginTop: "20px"}}>
		  
		
		  <div className="col-md-3">
            <div className="card" style={{ backgroundImage: 'linear-gradient(to right,#fff,#fff)', border: '1px solid rgba(0, 0, 0, 0.125)', boxShadow: ' 10px 10px rgba(0,0,0,0.2)', cursor:'pointer' }} onClick={() => this.nextPath("/market-target-lead/customer-particular-list", "Pipe Line")} >
              <CardBody className="pb-0">
                <div className="float-right">
                  <div className="icon_container">
                    <CancelIcon style={{ color: "red" }}></CancelIcon>
                  </div>
                </div>
              </CardBody>
              <center>
                <div className="text_contanier">
                  <h3 className="heading" style={{ color: "#000000", paddingTop: '2vh' }}>Pipe Line</h3>
                  <h5 className="value" style={{ color: "#000000" }}>{this.state.Marketingcount[5]}</h5>
                  {/* <h3 class="value" style={{ color: "#000000" }}>Offline {this.state.driverInActive}</h3> */}
                  <div className="chart-wrapper" style={{ height: '25px' }}></div>
                </div>
              </center>
            </div>
          </div>
		</Row>
		
        <div style={{ marginTop: '50px', display: 'none' }}> 
          <MUIDataTable
            title={"Today Orders"}
            data={this.state.orderDataArr}
            columns={customerColumns}
            options={customerOptions} />
        </div>
      </div>
    );

    const AccountsView = (
      <div>
        <Row>
          <div className="col-md-3" >

            <div className="card" style={{ backgroundImage: 'linear-gradient(to right,#fff,#fff)', border: '1px solid rgba(0, 0, 0, 0.125)', boxShadow: ' 10px 10px rgba(0,0,0,0.2)', cursor:'pointer' }} onClick={() => this.nextPath("/transaction/order/pendingorders")} >
              <CardBody className="pb-0">
                <div className="float-right">
                  <div className="icon_container">
                  <AccountBalanceIcon style={{ color: "green" }}></AccountBalanceIcon>
                  </div>
                </div>
              </CardBody>
              <center>
                <div className="text_contanier">
                  <h5 className="heading" style={{ color: "#000000", paddingTop: '2vh' }}>Customer Outstanding</h5>
                  <h3 className="value" style={{ color: "#000000" }}>Rs.{this.state.customer_outstanding}</h3>
                  {/*  <h3 class="value" style={{ color: "#000000" }}>Offline {this.state.borewellInActive}</h3> */}
                  <div className="chart-wrapper" style={{ height: '25px' }}></div>
                </div>
              </center>
            </div>
          </div>
          <div className="col-md-3" >
            <div className="card" style={{ backgroundImage: 'linear-gradient(to right,#fff,#fff)', border: '1px solid rgba(0, 0, 0, 0.125)', boxShadow: ' 10px 10px rgba(0,0,0,0.2)', cursor:'pointer' }} onClick={() => this.nextPath("/transaction/order/pendingorders")} >
              <CardBody className="pb-0">
                <div className="float-right">
                  <div className="icon_container">
                  <AccountBalanceIcon style={{ color: "red" }}></AccountBalanceIcon>
                  </div>
                </div>
              </CardBody>
              <center>
                <div className="text_contanier">
                  <h5 className="heading" style={{ color: "#000000", paddingTop: '2vh' }}>Tanker Payment</h5>
                  <h3 className="value" style={{ color: "#000000" }}>Rs.{this.state.tanker_payment}</h3>
                  {/* <h3 class="value" style={{ color: "#000000" }}>Offline {this.state.driverInActive}</h3> */}
                  <div className="chart-wrapper" style={{ height: '25px' }}></div>
                </div>
              </center>
            </div>
          </div>
          <div className="col-md-3">
            <div className="card" style={{ backgroundImage: 'linear-gradient(to right,#fff,#fff)', border: '1px solid rgba(0, 0, 0, 0.125)', boxShadow: ' 10px 10px rgba(0,0,0,0.2)', cursor:'pointer' }} onClick={() => this.nextPath("/transaction/order/pendingorders")} >
              <CardBody className="pb-0">
                <div className="float-right">
                  <div className="icon_container">
                    <AccountBalanceIcon style={{ color: "#0008ff" }}></AccountBalanceIcon>
                  </div>
                </div>
              </CardBody>
              <center>
                <div className="text_contanier">
                  <h5 className="heading" style={{ color: "#000000", paddingTop: '2vh' }}>Aggregators Amount</h5>
                  <h3 className="value" style={{ color: "#000000" }}>Rs.{this.state.aggregators_amount}</h3>
                  {/* <h3 class="value" style={{ color: "#000000" }}>Offline {this.state.driverInActive}</h3> */}
                  <div className="chart-wrapper" style={{ height: '25px' }}></div>
                </div>
              </center>
            </div>
          </div>
		  </Row>
		
        <div style={{ marginTop: '50px', display: 'none' }}> 
          <MUIDataTable
            title={"Today Orders"}
            data={this.state.orderDataArr}
            columns={customerColumns}
            options={customerOptions} />
        </div>
      </div>
    );

    let view = "";
    if (this.props.userRole === "Administrator" || this.props.userRole === "Super Admin" || this.props.userRole === "Support User" || this.props.userRole === "CRE" || this.props.userRole === "Logistics")
		  view = AdminView;
    else if (this.props.userRole === "Partner") 
	    view = PartnerView;
	  else if (this.props.userRole === "Marketing") 
	    view = MarketingView;
    else if (this.props.userRole === "Accounts") 
	    view = AccountsView;
    else view = UserView;

    return (<>
      <div>
      </div>
      {view}</>)
  }
}

const mapStateToProps = (state /*, ownProps*/) => {
  return {
    userRole: state.auth.user[0].userType,
    userId: state.auth.user[0].id,
	mobiledevice: state.auth.user[0].mobiledeviceId,
  }
}

export default connect(
  mapStateToProps,
  null
)(Dashboard)